import { MachineActions } from 'common/bento/types/MachineConfig';

import { Model } from './model';

// @ts-expect-error MachineActions error
const actions: MachineActions<Model, Action> = {};

export default actions;
